import { api } from './api'

export interface AIChatStatus {
  configured: boolean
  engine: string
}

export interface AIChatResponse {
  reply: string
  conversation_id: string
}

export const aiChatApi = {
  getStatus: (signal?: AbortSignal) =>
    api.get<AIChatStatus>('/ai-chat/status', { signal }),
  sendMessage: (message: string, conversationId?: string, signal?: AbortSignal) =>
    api.post<AIChatResponse>(
      '/ai-chat/messages',
      { message, conversation_id: conversationId },
      { timeout: 65000, signal },
    ),
}
